import React from 'react';
import propTypes from 'prop-types';
import { Spinner } from 'reactstrap';

/**
 * loading spinner to render when waiting for something (fetching/loading data)
 *
 * @function
 * @param {object} props - component props
 * @param {string} props.className - css class names
 * @param {string} props."data-test-id" - test id
 * @param {string} props.color - test id
 * @param {string} props.size - size
 * @param {object} props.style - styles object
 * @returns {React.Component} loading spinner
 */
const LoadingIndicator = ({ className, 'data-test-id': testId, color, size, style }) => (
  <div
    className={`d-flex align-items-center justify-content-center ${className}`}
    data-test-id={testId}
  >
    <Spinner color={color} size={size} style={style} type="grow" />
    <Spinner color={color} size={size} style={style} type="grow" />
    <Spinner color={color} size={size} style={style} type="grow" />
  </div>
);
LoadingIndicator.propTypes = {
  className: propTypes.string,
  'data-test-id': propTypes.string,
  color: propTypes.string,
  size: propTypes.string,
  style: propTypes.object
};
LoadingIndicator.defaultProps = {
  className: '',
  'data-test-id': LoadingIndicator.name,
  color: 'primary',
  size: 'lg',
  style: {}
};

export default LoadingIndicator;
